module.exports = __webpack_public_path__ + "img/photo-shixigang.d618c061.png";